import React, { useState, useRef, useEffect } from "react";
import {
  Tooltip,
  IconButton,
  Menu,
  MenuItem,
  ListItemText,
  Grid,
  Box,
} from "@material-ui/core";
import { Print } from "@material-ui/icons";
import useTranslate from "commons/hooks/useTranslate";
import usePrintTemplates from "commons/hooks/usePrintTemplates";
import { ComponentsMap } from "commons/pages/print-templates/BuilderComponents";
import { useReactToPrint } from "react-to-print";

export function usePrintManager() {
  const [active, setActive] = useState(null);
  const { templates } = usePrintTemplates();
  const onPrintRequest = (id) => {
    const template = templates.find((template) => template.id === id);
    if (template) {
      setActive(template);
    }
  };
  const onPrintCompleted = () => {
    setActive(null);
  };

  return { active, onPrintRequest, onPrintCompleted };
}

export function PrintTemplate({ active = null, onPrintCompleted, children }) {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: onPrintCompleted,
  });

  useEffect(() => {
    if (active !== null) {
      handlePrint();
    }
  }, [active, handlePrint]);

  return (
    <div ref={componentRef}>
      {active && active.header && (
        <div className="print-only">
          <PrintSectionViewer template={active.header} />
        </div>
      )}
      {children}
      {active && active.footer && (
        <div className="print-only">
          <PrintSectionViewer template={active.footer} />
        </div>
      )}
    </div>
  );
}

export function PrintButton({ onPrintRequest }) {
  const { t } = useTranslate();
  const { templates } = usePrintTemplates();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip title={t("print")}>
        <IconButton onClick={handleMenu}>
          <Print />
        </IconButton>
      </Tooltip>
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={open}
        onClose={handleClose}
      >
        {templates.map((template) => (
          <MenuItem
            key={template.id}
            onClick={() => onPrintRequest(template.id)}
          >
            <ListItemText primary={template.name} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

function PrintSectionViewer({ template = [] }) {
  return (
    <Grid container alignItems="flex-start" spacing={2}>
      {template.map((item) => {
        const CurrentComponent = ComponentsMap[item.type];
        return (
          <Grid item sm={parseInt(item.size)} key={item.id}>
            <Box
              display="flex"
              alignItems="flex-start"
              justifyContent={item.align}
            >
              <CurrentComponent item={item} />
            </Box>
          </Grid>
        );
      })}
    </Grid>
  );
}
